<template>
  <div class="contact-page">
    <nav-header :module="pageTitle" :class="{'register-head':pageTitle}"></nav-header>
    <div class="fixed-title">
      <div class="main">
        <h3 class="pdf-title">协议</h3>
        <div class="btn-primary" v-show="type==2" @click="callSendMsg">签约</div>
      </div>
    </div>
    <div class="container">
      <iframe class="iframe" :src="path" frameborder="0"></iframe>
    </div>
    <fixed-right></fixed-right>
    <my-dialog :show="showprompt" title="验证" width="520px" @close="showprompt=false">
      <div class="form">
        <div class="form-item">
          <span class="label">手机号：</span>
          <div class="input-box">
            <input type="text" v-model="phone" class="input" readonly>
          </div>
        </div>
        <div class="form-item">
          <span class="label">验证码：</span>
          <div class="input-box">
            <input type="text" v-model.trim="code" class="input">
            <button class="btn-code" @click="getCode" :disabled="isDiabled">{{btnText}}</button>
          </div>
        </div>
        <div class="btn-primary" @click="sign">确定</div>
      </div>
    </my-dialog>
  </div>
</template>

<script>
import navHeader from '@/components/navHeader.vue'
import FixedRight from '@/components/fixedRight.vue'
import MyDialog from '@/components/gkDialog.vue'
import {UserSignContract,TianWeiSendMobileCode,AddErrorLog} from '@/scripts/api.js'
import {mapState} from 'vuex'
import {isDev,BASEURL,ManageApiUrl} from '@/scripts/util.js'
export default {
  name: 'contract',
  components:{
    navHeader,
    FixedRight,
    MyDialog
  },
  data(){
    return{
      type:0,
      path:'',
      contractId:'',
      contractTemplateId:'',
      showprompt:false,
      phone:'',
      code:'',
      btnText:'获取验证码',
      isDiabled:false,
      timer:null,
      pageTitle:'',
      senceCode:0
    }
  },
  computed: {
    ...mapState({
      userInfo:state=>state.userInfo
    })
  },
  created() {
    this.phone=this.userInfo?this.userInfo.Handset:'';
    this.contractId = this.$route.query.contractId;
    this.contractTemplateId = this.$route.query.contractTemplateId;
    this.path =  `${ManageApiUrl}/pdf/web/viewer.html?file=${this.$route.query.path}`;
    this.type = this.$route.query.type;
    if(this.$route.query.senceCode)
    {
      this.senceCode=this.$route.query.senceCode;
    }
    this.pageTitle = this.$route.query.from=='register'?'大客户注册':'';
  },
  methods: {
    callSendMsg(){
      if(this.phone==''){
        this.$toast('请先绑定手机号');
        return;
      }
      if(!this.userInfo.RealNameStatus && this.$route.query.from!='register'){
        this.$toast('请先实名认证');
        if(this.userInfo.LoginAccountType==1){
          this.$router.push("/center/personRealName");
        }else
        if(this.userInfo.LoginAccountType==2){
          this.$router.push("/center/companyRealName");
        }
        return;
      }
      this.showprompt=true;
    },
    getCode(){
      var params={
        phone:this.phone,
        codeType:111,
        platform:'pcweb'
      }
      if(this.userInfo.LoginAccountType==1){
        params['loginUserId']=this.userInfo.LoginAccountId;
      }else
      if(this.userInfo.LoginAccountType==2){
        params['loginCompanyId']=this.userInfo.LoginAccountId;
      }
      TianWeiSendMobileCode(params).then(r=>{
        if(r.Result==1){
          this.$toast('发送成功！');
          this.isDiabled=true;
          let sec=60;
          this.timer=setInterval(() => {
            sec--;
            this.btnText=`${sec}s`;
            if(sec<=0){
              clearInterval(this.timer);
              this.btnText='获取验证码';
              this.isDiabled=false;
            }
          }, 1000);
        }else{
          this.$toast(r.Message);
        }
      })
    },
    sign(){
      let params={
        mobileCode:this.code,
        userHandset:this.phone,
        contractId:this.contractId,
        contractTemplateId:this.contractTemplateId,
        IsRegisterBigCustomer:this.$route.query.from=='register'?true:false,
        senceCode:this.senceCode,
        platForm:'pcweb',
        
      }
      if(this.userInfo.LoginAccountType==1){
        params['loginUserId']=this.userInfo.LoginAccountId;
      }else
      if(this.userInfo.LoginAccountType==2){
        params['loginCompanyId']=this.userInfo.LoginAccountId;
      }
      UserSignContract(params).then(async r=>{
        if(r.Result==1){
          this.showprompt=false;
          this.$toast(r.Message);
          this.type=1;
          if(this.$route.query.from=='register'){
            await this.$store.dispatch('loadAccountData');
            await this.$store.dispatch('loadPermission');
            this.$router.replace('/home');
            return;
          }
          if(this.userInfo.LoginAccountType==1){
            this.$router.back(1);
          }
          if(this.userInfo.LoginAccountType==2){
            this.$router.back(1);
          }
      
        }else if(r.Result==610){
          this.$router.push('/center/companyRealName');
        }else{
          this.$toast(r.Message);
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer=null;
  },
}
</script>

<style lang="scss">
.contact-page{
  .register-head{
    .user-area{
      display: none;
    }
  }
  .fixed-title{
    position: fixed;
    left: 0;
    top: 68px;
    width: 100%;
    height: 70px;
    background-color: #e5e5e5;
    box-shadow:2px 5px 10px 0px rgba(8,1,3,0.16);
    z-index: 2;
    .main{
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
    }
    .pdf-title{
      font-size: 18px;
      color: #333;
      line-height: 70px;
      text-align: center;
    }
    .btn-primary{
      position: absolute;
      right: 0;
      top: 20px;
      background-color: #f75959;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      &:hover{
        background-color: #ff3838;
      }
    }
  }
  .container{
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    padding-top: 138px;
    overflow: hidden;
    position: fixed;
    left: 50%;
    top: 0;
    height: 100%;
    background-color: #f8f8f8;
    margin-left: -600px;
    .iframe{
      width: 100%;
      height: 100%;
    }
  }
  .form{
    padding: 20px 20px 0;
    .form-item{
      overflow: hidden;
      width: 440px;
      margin-bottom: 20px;
    }
    .label{
      float: left;
      width: 80px;
      font-size: 14px;
      color: #333;
      line-height: 34px;
    }
    .input-box{
      float: left;
      width: 360px;
      overflow: hidden;
      position: relative;
    }
    .input{
      width: 100%;
      height: 34px;
      border: 1px solid #e5e5e5;
      padding: 4px 10px;
      font-size: 14px;
      color: #333;
      line-height: 22px;
    }
    .btn-code{
      position: absolute;
      right: 0;
      top: 0;
      width: 100px;
      height: 34px;
      background-color: #f8f8f8;
      font-size: 12px;
      color: #333;
      line-height: 32px;
      border: 1px solid #e5e5e5;
      font-family: inherit;
    }
    .btn-primary{
      font-size: 14px;
      color: #fff;
      line-height: 32px;
      height: 32px;
      width: 100px;
      background-color: #f75959;
      text-align: center;
      margin: 40px auto 0;
      cursor: pointer;
      &:hover{
        background-color: #ff3838;
      }
    }
  }
}


</style>